<template>
  <div class="main">
    <!-- PC端头部 -->
    <div v-if="!isPhone">
      <div class="header">
        <h3>客户解决方案</h3>
        <img class="main_img" src="../../assets/images/客户案例/顶部/矢量智能对象.png" alt=""/>
        <img class="cloud" src="../../assets/images/客户案例/顶部/图层602.png" alt=""/>
        <img class="light_1" src="../../assets/images/客户案例/顶部/图层599.png" alt=""/>
        <img class="light_2" src="../../assets/images/客户案例/顶部/图层600.png" alt=""/>
        <img class="light_5" src="../../assets/images/客户案例/顶部/图层600.png" alt=""/>
        <img class="light_6" src="../../assets/images/客户案例/顶部/图层589.png" alt=""/>
        <img class="light_3" src="../../assets/images/客户案例/顶部/图层601.png" alt=""/>
        <img class="light_4" src="../../assets/images/客户案例/顶部/图层603.png" alt=""/>
        <img class="block" src="../../assets/images/客户案例/顶部/图层590.png" alt=""/>
      </div>
    </div>
    <!-- 手机端头部 -->
    <div v-if="isPhone">
      <div class="header">
        <h3>客户解决方案</h3>
        <img src="../../assets/images/客户案例/公安/组19.png" alt=""/>
      </div>
    </div>

    <div class="content_box">
      <div class="content title_box">
        <div class="top_title"><p>精选案例</p></div>
        <div class="bottom_title">
          <ul>
            <li :class="[viewInidex === 0 ? 'li_2' : 'li_1']" @click="topTitleClick(0)">
              <span>政企单位</span>
            </li>
            <li :class="[viewInidex === 1 ? 'li_2' : 'li_1']" @click="topTitleClick(1)">
              <span>公安机构</span>
            </li>
            <li :class="[viewInidex === 2 ? 'li_2' : 'li_1']" @click="topTitleClick(2)">
              <span>教育行业</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 政企 -->
      <div v-show="viewInidex === 0" class="main_content">
        <div class="content_1">
          <div class="left_img_box">
            <img class="left_img" src="../../assets/images/客户案例/政企/组19.png" alt=""/>
          </div>

          <div class="right_textbox">
            <img class="yinhao" src="../../assets/images/客户案例/公安/”.png" alt="">
            <p class="title">场景需求</p>
            <p class="txt">{{zhengqiText}}</p>
          </div>
        </div>
        <div class="content_2">
          <div class="top_title">
            <p>行业痛点</p>
          </div>
          <div class="bottom_content2">
            <div class="tag_box" v-for="(item,index) in zhengqiList" :key="index" @mouseenter="changeImg(index)" @mouseleave="changeImg2(index)">
              <img :src="imgchange === index ? item.img2 : item.img" alt="">
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
        <div class="content_3">

          <div v-if="!isPhone">
            <div class="top_title">
              <p>解决方案</p>
              <span>方案采用“1+1+3”架构</span>
            </div>
            <div class="bottom_content3" v-for="(item,index) in zhengqifangan" :key="index">
              <img v-if="index === 1" :src="item.img" alt=""/>
              <div class="text_box">
                <div class="title3">
                  <div class="line"></div>
                  <span>{{item.title}}</span>
                </div>
                <p>{{item.content}}</p>
              </div>
              <img v-if="index !== 1" :src="item.img" alt=""/>
            </div>
          </div>

          <div v-if="isPhone">
            <div class="top_title">
              <p>解决方案</p>
            </div>
            <div class="bottom_content3" v-for="(item,index) in zhengqifangan" :key="index">
              <img :src="item.img" alt=""/>
              <div class="text_box">
                <div class="title3">
                  <div class="line"></div>
                  <span>{{item.title}}</span>
                </div>
                <p>{{item.content}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- 公安 -->
      <div  v-show="viewInidex === 1" class="main_content">
        <div class="content_1">
          <div class="left_img_box">
            <img class="left_img" src="../../assets/images/客户案例/公安/组20.png" alt="">
          </div>

          <div class="right_textbox">
            <img class="yinhao" src="../../assets/images/客户案例/公安/”.png" alt="">
            <p class="title">场景需求</p>
            <p class="txt">{{gonganText}}</p>
          </div>
        </div>
        <div class="content_2">
          <div class="top_title">
            <p>行业价值</p>
          </div>
          <div class="bottom_content2">
            <div class="tag_box2" v-for="(item,index) in gonganList" :key="index" @mouseenter="changeImg(index)" @mouseleave="changeImg2(index)">
              <img :src="imgchange === index ? item.img2 : item.img" alt="">
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
        <div class="content_3">

          <div class="top_title">
            <p>解决方案</p>
          </div>
          <!-- 手机端 -->
          <div v-if="isPhone">
            <div class="bottom_title">
              <ul>
                <li :class="[bottomIndex === 0 ? 'li_2' : 'li_1']" style="margin: 0px 50px;" @click="bottomTitleClick(0)">
                  <span>产品亮点</span>
                </li>
                &emsp;
                <li :class="[bottomIndex === 1 ? 'li_2' : 'li_1']" style="margin: 0px 50px;" @click="bottomTitleClick(1)">
                  <span>技术支持</span>
                </li>
              </ul>
            </div>
            <div v-show="bottomIndex === 0" class="bottom_content4_1">
              <img src="../../assets/images/客户案例/公安/组21.png" alt="">
              <div class="left_textbox">
                <div class="main_textbox">
                  <p class="main_title">大数据平台解决方案</p>
                  <p class="main_text">掌网信息结合十年的信息化建设经验，以自主研发的域贝大数据平台产品为核心，设计了大数据平台解决方案，包括</p>
                  <div class="tag_title" v-for="(item,index) in jinwu1" :key="index">
                    <div class="circle"></div>
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="bottomIndex === 1" class="bottom_content4_2">
              <img src="../../assets/images/客户案例/公安/组22.png" alt="">
              <div class="left_textbox">
                <div class="main_textbox">
                  <p class="main_title">技术层面</p>
                  <div class="tag_title" v-for="(item,index) in jinwu2" :key="index">
                    <div class="circle"></div>
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- pc端 -->
          <div v-if="!isPhone">
            <div class="bottom_content4_1">
              <div class="img_box">
                <img src="../../assets/images/客户案例/公安/组21.png" alt="">
              </div>
              <div class="left_textbox">
                <div class="main_textbox">
                  <p class="main_title">大数据平台解决方案</p>
                  <p class="main_text">掌网信息结合十年的信息化建设经验，以自主研发的域贝大数据平台产品为核心，设计了大数据平台解决方案，包括</p>
                  <div class="tag_title" v-for="(item,index) in jinwu1" :key="index">
                    <div class="circle"></div>
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom_content4_2">
              <div class="img_box">
                <img src="../../assets/images/客户案例/公安/组22.png" alt="">
              </div>
              <div class="left_textbox">
                <div class="main_textbox">
                  <p class="main_title">技术层面</p>
                  <div class="tag_title" v-for="(item,index) in jinwu2" :key="index">
                    <div class="circle"></div>
                    <p>{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- 教育 -->
      <div  v-show="viewInidex === 2" class="main_content">
        <div class="content_1">
          <div class="left_img_box">
            <img class="left_img" src="../../assets/images/客户案例/教育/组19.png" alt="">
          </div>

          <div class="right_textbox">
            <img class="yinhao" src="../../assets/images/客户案例/公安/”.png" alt="">
            <p class="title">场景需求</p>
            <p class="txt">{{jiaoyuText}}</p>
          </div>
        </div>
        <div class="content_2">
          <div class="top_title">
            <p>行业痛点</p>
          </div>
          <div class="bottom_content2">
            <div class="tag_box" v-for="(item,index) in jiaoyuList" :key="index" @mouseenter="changeImg(index)" @mouseleave="changeImg2(index)">
              <img :src="imgchange === index ? item.img2 : item.img" alt="">
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
        <div class="content_3">

          <div class="top_title">
            <p>解决方案</p>
          </div>

          <div v-if="!isPhone">
            <div class="bottom_content3" v-for="(item,index) in jiaoyufangan" :key="index">
              <img v-if="index === 1" :src="item.img" alt=""/>
              <div class="text_box">
                <div class="title3">
                  <div class="line"></div>
                  <span>{{item.title}}</span>
                </div>
                <p>{{item.content}}</p>
              </div>
              <img v-if="index !== 1" :src="item.img" alt=""/>
            </div>
          </div>

          <div v-if="isPhone">
            <div class="bottom_content3" v-for="(item,index) in jiaoyufangan" :key="index">
              <img :src="item.img" alt=""/>
              <div class="text_box">
                <div class="title3">
                  <div class="line"></div>
                  <span>{{item.title}}</span>
                </div>
                <p>{{item.content}}</p>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewInidex: 0,
      isPhone: false,
      // 政企
      zhengqiText: '当前，城市道路交通正处于高速发展阶段,路桥的巡检工作必不可少,保障公路桥梁完好畅通,进一步 加强路桥的养护规范化管理水平已成为迫切需要。市政道路工程建设公司会定期定点的对道路桥梁来进行巡检,从而及时发现问题,进而进行维护、检测,及时消除路桥的隐患,将隐患消灭于萌芽状态。',
      zhengqiList:[
        {
          img: require('../../assets/images/客户案例/政企/数据标准.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/数据标准(1).png'),
          title: '缺少统一的标准'
        },
        {
          img: require('../../assets/images/客户案例/政企/沟通.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/沟通.png'),
          title: '缺少有效的沟通'
        },
        {
          img: require('../../assets/images/客户案例/政企/审批.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/审批.png'),
          title: '冗长的审批过程'
        }
      ],
      zhengqifangan:[
        {
          title: '一张图',
          content: '一张数据治理图，将各个业务场景通过一张图的方式进行直观动态展示',
          img: require('../../assets/images/客户案例/政企/组20.png')
        },
        {
          title: '一体化平台',
          content: '一体化平台，实现统一认证统一标准统一接口的底层服务',
          img: require('../../assets/images/客户案例/政企/组21.png')
        },
        {
          title: '三端融合',
          content: '三端融合，无缝融合电脑端、手机端、平板端系统，实现工程管理、人员管理、设备管理、流程管理、工单管理等项目全生命周期闭环管理',
          img: require('../../assets/images/客户案例/政企/组22.png')
        }
      ],
      // 公安
      bottomIndex: 0,
      gonganText: '当前，随着社会经济发展，数字化改革持续推进，社会化数据越来越丰富，但是这些重要数据分散在各类系统中，如果能利用大数据、云计算、物联网、人工智能等先进的信息化科技手段，将这些海量异构的数据汇聚，从而形成数据合力，挖掘数据价值。',
      gonganList:[
        {
          img: require('../../assets/images/客户案例/公安/实战.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/实战.png'),
          title: '提升工作能力'
        },
        {
          img: require('../../assets/images/客户案例/公安/安保统计.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/安保统计.png'),
          title: '安保防卫能力'
        },
        {
          img: require('../../assets/images/客户案例/公安/疫情防控.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/疫情防控.png'),
          title: '防控保障能力'
        },
        {
          img: require('../../assets/images/客户案例/公安/治安防控.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/治安防控.png'),
          title: '治安防恐能力'
        },
        {
          img: require('../../assets/images/客户案例/公安/社会治安.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/社会治安.png'),
          title: '社会综治能力'
        }
      ],
      jinwu1: [
        {
          title: 'ETL数据源同步管理',
        },
        {
          title: '实时数据预警预报',
        },
        {
          title: '一键式快速查询等高级实用功能模块',
        },
        {
          title: '实现了数据采集、数据清洗、数据存储、数据分析、数据应用等数据全流程全生命周期使用。',
        }
      ],
      jinwu2: [
        {
          title: '平台使用Java语言开发',
        },
        {
          title: '采用主流的微服务技术架构',
        },
        {
          title: '自主研发的瑶池数据仓库具备支持PB级数据存储',
        },
        {
          title: '基于全文检索引擎Lucene的数据查询效率可达毫秒级',
        },
        {
          title: '支持单日亿级数据的吞吐量',
        },
        {
          title: '完全满足大数据系统海量、异构、全域的数据汇聚需求。',
        }
      ],
      // 教育
      jiaoyuText: '根据《浙江省教育领域数字化改革工作方案》指示，建设“教育魔方”工程，统筹推 进数字技术与教育管理、教育教学广泛深度融合，5G、物联网、区块链等新一代信息技术在教育领域应用日益成熟，行业云、数字校园等教育行业数字基础设施稳步发展，贯通各教育阶段、覆盖各治理场景的教育大数据逐步丰富，适应数字时代的全民学习体系持续完善，数字化、空间化、一体化的教育治理能力基本形成。',
      jiaoyuList:[
        {
          img: require('../../assets/images/客户案例/教育/推广者分析.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/推广者分析.png'),
          title: '信息孤岛'
        },
        {
          img: require('../../assets/images/客户案例/教育/发现.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/发现.png'),
          title: '应用孤岛'
        },
        {
          img: require('../../assets/images/客户案例/教育/图标.png'),
          img2: require('../../assets/images/客户案例/解决方案图标蓝色/图标_Previouspage副本.png'),
          title: '资源孤岛'
        }
      ],
      jiaoyufangan:[
        {
          title: '一平台',
          content: '即智慧教育一体化平台，实现用户账号统一认证、基础数据标准化、三方应用出入管控等基础性底座功能;',
          img: require('../../assets/images/客户案例/教育/组20.png')
        },
        {
          title: '一中心',
          content: '即智慧教育大数据中心，形成具有数据采集、治理、资产、分析、应用、服务等功能的大数据中心，并通过数据服务为各个业务系统进行数据赋能;',
          img: require('../../assets/images/客户案例/教育/组21.png')
        },
        {
          title: 'N场景',
          content: '即多个业务场景应用，包括学生评价、教师发展、校园安防、校园文化等多个场景应用，通过多维度数字画像驱动场景化应用推进;',
          img: require('../../assets/images/客户案例/教育/组22.png')
        }
      ],
      imgchange: -1,
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.documentElement.clientWidth; //实时宽度
        window.screenHeight = document.documentElement.clientHeight; //实时高度
        console.log(window.screenWidth);
        window.screenWidth <= 750 ? this.isPhone = true : this.isPhone = false;
      })();
    };
  },
  methods: {
    topTitleClick(index) {
      this.viewInidex = index
    },
    bottomTitleClick(index) {
      this.bottomIndex = index
    },
    changeImg(index) {
      this.imgchange = index
    },
    changeImg2(index) {
      this.imgchange = -1
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  .header {
      height: 670px;
      width: 100%;
      background: url('../../assets/images/客户案例/公安/bg.png');
    h3 {
      position: absolute;
      // top: 350px;
      line-height: 670px;
      left: 20%;
      font-size: 40px;
      font-weight: 500;
      color: #23405a;
      font-family: AlibabaPuHuiTi_ 2_ 85_ Bold;
      z-index: 100;
    }
    .main_img {
      position: relative;
      float: right;
      right: 170px;
    }
    .cloud {
      position: relative;
      float: right;
      top: 10px;
      right: 10px;
      animation: move1 3s infinite;
    }
    .light_1 {
      position: relative;
      float: right;
      top: 100px;
      // right: 290px;
      opacity: 0;
      animation: shink 4s infinite;
      animation-delay: 1s;
    }
    .light_2 {
      position: relative;
      float: right;
      top: 480px;
      // right: 180px;
      opacity: 0;
      animation: shink 3.5s infinite;
      animation-delay: 2s;
    }
    .light_3 {
      position: relative;
      float: right;
      top: 400px;
      // left: 170px;
      opacity: 0;
      animation: shink 3.8s infinite;
      animation-delay: 3s;
    }
    .light_4 {
      position: relative;
      float: right;
      top: 350px;
      // left: 620px;
      opacity: 0;
      animation: shink 4.3s infinite;
      animation-delay: 2s;
    }
    .light_5 {
      position: relative;
      float: right;
      top: 440px;
      // right: 450px;
      opacity: 0;
      animation: shink 4.1s infinite;
      animation-delay: 1.5s;
    }
    .light_6 {
      position: relative;
      float: right;
      top: 500px;
      // right: 340px;
      opacity: 0;
      animation: shink 4.6s infinite;
      animation-delay: 2.2s;
    }
    .block {
      position: relative;
      float: right;
      top: 80px;
      // right: 250px;
      animation: move2 3s infinite;
    }
  }
  @keyframes shink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes move1 {
    0% {
      top: 10px;
    }
    50% {
      top: 30px;
    }
    100% {
      top: 10px;
    }
  }
  @keyframes move2 {
    0% {
      top: 80px;
    }
    50% {
      top: 110px;
    }
    100% {
      top: 80px;
    }
  }

  .content_box {
    .title_box {
      position: relative;
      width: 100%;
      height: 200px;
      .top_title {
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          color: #23405a;
          font-size: 30px;
        }
      }

    }
    .bottom_title {
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        ul {
          .li_1 {
            list-style: none;
            display: inline-block;
            height: 60px;
            margin: 80px;
            color: black;
            line-height: 60px;
            font-size: 18px;
            &:hover {
              color: #3186fd;
            }
          }
          .li_1:hover:after {
            color: #fff;
            content: '';
            width: 30px;
            height: 10px;
            display: block;
            margin: -10px auto;
            border-bottom: 3px solid #f6412c;
          }
          .li_2 {
            list-style: none;
            display: inline-block;
            height: 60px;
            margin: 80px;
            line-height: 60px;
            font-size: 18px;
            color: #3186fd;
          }
          .li_2::after {
            content: '';
            width: 30px;
            height: 10px;
            display: block;
            margin: -10px auto;
            border-bottom: 3px solid #f6412c;
          }
        }
      }
    .main_content {
      width: 1200px;
      margin: 35px auto;
      .content_1 {
        width: 100%;
        height: 441px;
        // overflow: hidden;
        .left_img_box {
          float: left;
          width: 420px;
          height: 441px;
          z-index: 2;
          overflow: hidden;
          &:hover {
            .left_img {
              transform: scale(1.05);
            }
          }
          .left_img {
            // float: left;
            // width: 420px;
            // height: 441px;
            z-index: 2;
            transition: .8s;

          }
        }

        .right_textbox {
          position: absolute;
          float: right;
          width: 840px;
          height: 370px;
          margin-top: 38px;
          margin-left: 360px;
          z-index: -1;
          box-shadow:2px 5px 10px 4px rgba(0, 0, 0, .1);
          .yinhao {
            position: absolute;
            top: 35px;
            left: 730px;
          }
          .title {
            position: relative;
            color: #23405a;
            top: 64px;
            left: 140px;
            font-size: 20px;
          }
          .txt {
            position: relative;
            font-size: 18px;
            width: 600px;
            color: #666;
            top: 84px;
            left: 140px;
            line-height: 30px;
            text-indent: 2em;
            text-align: justify;
          }
        }
      }
      .content_2 {
        width: 100%;
        height: 400px;
        margin-top: 90px;
        .top_title {
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            color: #23405a;
            font-size: 30px;
          }
        }
        .bottom_content2 {
          width: 100%;
          height: 300px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .tag_box {
            width: 386px;
            height: 219px;
            border-radius: 5px;
            border: rgb(223, 223, 223) 1px solid;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            p {
              margin-top: 33px;
              color: #23405a;
              font-size: 18px;
            }
            &:hover {
              box-shadow:1px 2px 5px 2px rgba(0, 0, 0, .1);
              p {
                color: #3186fd;
              }
            }
          }
          .tag_box2 {
            width: 232px;
            height: 219px;
            border-radius: 5px;
            border: rgb(223, 223, 223) 1px solid;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            p {
              margin-top: 33px;
              color: #23405a;
              font-size: 18px;
            }
            &:hover {
              box-shadow:1px 2px 5px 2px rgba(0, 0, 0, .1);
              p {
                color: #3186fd;
              }
            }
          }
        }
      }
      .content_3 {
        width: 100%;
        margin-top: 90px;
        .top_title {
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          p {
            color: #23405a;
            font-size: 30px;
          }
          span {
            color: #5b81a2;
            font-size: 16px;
            margin-top: 20px;
          }
        }
        .bottom_content3 {
          width: 1040px;
          height: 350px;
          // margin-top: 80px;
          margin: 80px auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            transition: .8s;
            &:hover {
              transform: translateY(-20px);
            }
          }
          .text_box {
            width: 400px;
            height: 140px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            // align-items: center;
            .title3 {
              width: 200px;
              height: 20px;
              display: block;
              display: flex;
              flex-direction: row;
              .line {
                width: 4px;
                height: 20px;
                background-color: #3186fd;
              }
              span {
                margin-left: 12px;
                font-size: 18px;
                color: #23405a;
              }
            }
          }
          p {
            font-size: 14px;
            margin-top: 30px;
            color: #475d73;
            text-indent: 2em;
            line-height: 25px;
          }
        }
        .bottom_content3:last-child {
          margin-bottom: 80px;
        }
        .bottom_content4_1,.bottom_content4_2 {
          width: 100%;
          height: 543px;
          margin-top: 80px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          .img_box {
            width: 1200px;
            height: 543px;
            z-index: 1;
            position: absolute;
            overflow: hidden;
            &:hover {
              img {
                transform: scale(1.1);
              }
            }
            img {
              transition: .5s;
              // z-index: -1;
            }
          }

          .left_textbox {
            position: relative;
            width: 540px;
            height: 340px;
            border-radius: 5px;
            background-color: rgba(247, 247, 247, 0.9);
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            .main_textbox {
              width: 443px;
              height: 256px;
              display: flex;
              flex-direction: column;
              .main_title {
                font-size: 30px;
                color: #23405a;
              }
              .main_text {
                margin-top: 17px;
                margin-bottom: 10px;
                font-size: 12px;
                color: #5b81a2;
              }
            }
            .tag_title {
              width: 100%;
              height: 37px;
              margin-top: 5px;
              display: flex;
              flex-direction: row;
              .circle {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin-top: 5px;
                background-color: #3186fd;
              }
              p {
                margin-left: 10px;
                font-size: 14px;
                flex: 1;
                color: rgba(71, 93, 115, 0.9);
              }
            }
          }
        }
        .bottom_content4_2 {
          margin-bottom: 80px;
          justify-content: flex-end;
          .main_title {
            margin-bottom: 30px;
          }
          .tag_title {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .main{
    .header {
      h3 {
        line-height: 670px;
        // top: 260px;
        left: 7%;
      }
      .main_img {
        position: relative;
        float: right;
        right: 150px;
      }
      .cloud {
        position: relative;
        float: right;
        top: 10px;
        left: 200px;
        animation: move1 3s infinite;
      }
      .light_1 {
        position: relative;
        float: right;
        top: 100px;
        right: 70px;
        opacity: 0;
        animation: shink 4s infinite;
        animation-delay: 1s;
      }
      .light_2 {
        position: relative;
        float: right;
        top: 480px;
        right: 80px;
        opacity: 0;
        animation: shink 3.5s infinite;
        animation-delay: 2s;
      }
      .light_3 {
        position: relative;
        float: right;
        top: 400px;
        left: 400px;
        opacity: 0;
        animation: shink 3.8s infinite;
        animation-delay: 3s;
      }
      .light_4 {
        position: relative;
        float: right;
        top: 350px;
        left: 850px;
        opacity: 0;
        animation: shink 4.3s infinite;
        animation-delay: 2s;
      }
      .light_5 {
        position: relative;
        float: right;
        top: 440px;
        right: 450px;
        opacity: 0;
        animation: shink 4.1s infinite;
        animation-delay: 1.5s;
      }
      .light_6 {
        position: relative;
        float: right;
        top: 500px;
        right: 340px;
        opacity: 0;
        animation: shink 4.6s infinite;
        animation-delay: 2.2s;
      }
      .block {
        position: absolute;
        // float: left;
        top: 80px;
        left: 200px;
        // right: 250px;
        animation: move2 3s infinite;
      }
    }
  }
}
@media (max-width: 750px) {
  .main {
    .header {
      width: 100vw;
      height: 240px;
      // background: #236dd4;
      background: url('../../assets/images/客户案例/公安/bg.png');
      background-size: 100% 100%;
      img {
        width: 100vw;
        height: 240px;
      }
      h3 {
        position: absolute;
        top: 100px;
        left: 20px;
        font-size: 1.2rem;
        font-weight: 600;
      }
    }
    .content_box {
      .title_box {
        width: 100vw;
        height: 100px;
        margin-top: 30px;
        .top_title {
          p {
            color: #23405a;
            font-size: 1.3rem;
            font-weight: 600;
          }
        }
        .bottom_title {
          justify-content: flex-start;
          ul {
            .li_1 {
              // margin-left: 20px;
              margin: 10px;
            }
            .li_2 {
              // margin-left: 20px;
              margin: 10px;
            }
          }
        }
      }
      .main_content {
        width: 90vw;
        margin: 35px auto;
        .content_1 {
          width: 100vw;
          height: 300px;
          overflow: hidden;
          .left_img {
            // float: left;
            width: 90vw;
            height: 150px;
            z-index: 2;
            object-fit: cover;
          }
          .right_textbox {
            width: 90vw;
            height: 150px;
            margin-top: 170px;
            margin-left: 0px;
            box-shadow:0px 0px 0px 0px rgba(0, 0, 0, .1);
            .yinhao {
              position: absolute;
              height: 30px;
              top: 20px;
              left: 85vw;
            }
            .title {
              top: 0px;
              left: 0px;
              font-size: 1.1rem;
            }
            .txt {
              width: 85vw;
              top: 20px;
              left: 2.5vw;
              color: #475d73;
              line-height: 18px;
              text-indent: 0em;
              font-size: .95rem;
            }
          }
        }
        .content_2 {
          width: 100vw;
          height: auto;
          margin-top: 90px;
          .top_title {
            width: 90vw;
            height: 50px;
            p {
              font-size: 1.2rem;
              font-weight: 600;
            }
          }
          .bottom_content2 {
            width: 100vw;
            height: auto;
            margin-left: -5vw;
            display: flex;
            // justify-content: center;
            flex-flow: row wrap;
            align-content: flex-start;
            .tag_box {
              width: 30vw;
              height: 100px;
              margin: 5px;
              border: rgb(223, 223, 223) 0px solid;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              img {
                height: 32px;
              }
              p {
                margin-top: 20px;
                color: #23405a;
                font-size: 1rem;
              }
              &:hover {
                box-shadow:1px 2px 5px 2px rgba(0, 0, 0, .1);
                p {
                  color: #3186fd;
                }
              }
            }
            .tag_box2 {
              width: 45vw;
              height: 100px;
              border-radius: 5px;
              border: rgb(223, 223, 223) 0px solid;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              img {
                height: 32px;
              }
              p {
                margin-top: 20px;
                color: #23405a;
                font-size: 1rem;
              }
              &:hover {
                box-shadow:1px 2px 5px 2px rgba(0, 0, 0, .1);
              }
            }
          }
        }
        .content_3 {
          width: 90vw;
          margin-top: 20px;
          .top_title {
            width: 90vw;
            height: 50px;
            p {
              color: #23405a;
              font-size: 1.2rem;
              font-weight: 600;
            }
          }
          .bottom_content3 {
            width: 90vw;
            height: 350px;
            margin-top: 0px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            img {
              height: 120px;
              transition: .8s;
              &:hover {
                transform: translateY(-20px);
              }
            }
            .text_box {
              width: 90vw;
              height: 140px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .title3 {
                width: auto;
                height: 20px;
                display: block;
                display: flex;
                flex-direction: row;
                .line {
                  width: 4px;
                  height: 20px;
                  background-color: #3186fd;
                  border-radius: 2px;
                }
                span {
                  margin-left: 5px;
                  font-size: 1rem;
                  font-weight: 600;
                }
              }
            }
            p {
              text-align: center;
              font-size: .9rem;
              margin-top: 30px;
              color: #475d73;
              text-indent: 0em;
              line-height: 18px;
            }
          }
          .bottom_content3:last-child {
            margin-bottom: 0px;
          }
          .bottom_content4_1,.bottom_content4_2 {
            width: 90vw;
            height: 525px;
            margin-top: 40px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            flex-direction: column;
            img {
              width: 90vw;
              height: 200px;
              position: relative;
              z-index: 1;
            }
            .left_textbox {
              width: 90vw;
              height: 300px;
              background-color: transparent;
              .main_textbox {
                width: 90vw;
                height: 256px;
                display: flex;
                flex-direction: column;
                .main_title {
                  font-size: 1.2rem;
                }
                .main_text {
                  width: 82vw;
                  margin-left: 4vw;
                  margin-top: 17px;
                  margin-bottom: 10px;
                  font-size: .9rem;
                  color: #475d73;
                }
              }
              .tag_title {
                width: 100%;
                height: auto;
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                .circle {
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  margin-top: 5px;
                  background-color: #3186fd;
                }
                p {
                  margin-left: 10px;
                  font-size: .9rem;
                  flex: 1;
                  color: #475d73;
                }
              }
            }
          }
          .bottom_content4_2 {
            margin-top: 27px;
            margin-bottom: 20px;
            justify-content: center;
            .main_title {
              margin-bottom: 0px;
            }
            .tag_title {
              margin-top: 10px;
            }
          }
        }



      }






    }
  }
}
</style>
